// extracted by mini-css-extract-plugin
export default {"control":"style_control__1lwE2","box":"style_box__MzGWs","input":"style_input__VSbIh","small_text":"style_small_text__iLIPd"};